<template>
  <div class="cart">
    <div class="container">
      <div class="cart__wrapper">
        <div class="cart__inner">
          <h1 class="cart__inner-title">{{ t('cart.title') }}</h1>
          <router-link :to="translations.i18nRoute({ name: 'store' })" class="cart__inner-block">
            <img src="@icons/backArrow.svg" alt="arrow">
            <p>{{ t('continueShop') }}</p>
          </router-link>
          <div class="cart__inner-line"></div>
          <div class="cart__inner-subtitle">{{ t('cart.subtitle') }}</div>
          <div class="cart__inner-text">{{ t('cart.text1') }} {{ productInCartQuantity }} {{ t('cart.text2') }}</div>
          <div class="cart__list">
            <cart-card
                v-for="product in productsInCart"
                :key="product.node.product.uuid"
                :product="product.node"
            />
          </div>
        </div>
        <cart-checkout />
      </div>
    </div>
  </div>
</template>

<script setup>
import CartCheckout from "@/components/cart/cart-checkout.vue";
import translations from "@/core/helpers/translations.js";
import {useI18n} from "vue-i18n";
import {computed} from "vue";
import {useCartStore} from "@/stores/cart.js";
import CartCard from "@/components/cart/cart-card.vue";

const {t} = useI18n()
const cartStore = useCartStore()

const productInCartQuantity = computed(() => {
  let count = 0
  cartStore.currentOrder.orderProducts?.edges.forEach((el) => {
    count = count + el.node.quantity
  })

  return count
})

const productsInCart = computed(() => {
  return cartStore.currentOrder.orderProducts ? cartStore.currentOrder.orderProducts.edges : []
})
</script>

<style lang="scss" scoped>
.cart {
  background-image: url(@images/bg/cartBg.png);

  &__wrapper {
    display: flex;
    align-items: flex-start;
    gap: 100px;
  }

  &__inner {
    width: 100%;
    background-color: $white;
    padding: 50px;
    min-height: 80vh;

    &-title {
      padding-left: 38px;
      color: #1e1e1e;
      font-family: Poppins, sans-serif;
      font-size: 28px;
      font-weight: 700;
    }

    &-block {
      cursor: pointer;
      display: flex;
      align-items: center;

      & p {
        color: #1e1e1e;
        font-family: Poppins, sans-serif;
        font-size: 28px;
        font-weight: 600;
      }
    }

    &-line {
      margin-block: 20px;
      background-color: $black;
      width: 100%;
      height: 1px;
    }

    &-subtitle {
      color: #1e1e1e;
      font-family: Poppins, sans-serif;
      font-size: 18px;
      font-weight: 500;
    }

    &-text {
      color: #1e1e1e;
      font-family: Nunito, sans-serif;
      font-size: 14px;
      font-weight: 500;
    }
  }

  &__list {
    margin-top: 35px;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
}

@media (max-width: 1300px) {
  .cart {
    &__wrapper {
      flex-direction: column-reverse;
      align-items: center;
      gap: 0;
    }

    &__inner {
      min-height: 10vh;
    }
  }
}
</style>